/**
 * The relation types Codex writes into `spec.codexRelations`, each with the
 * relation it becomes on the source and the reverse relation on the target.
 * The type Codex sends is the forward name (`RELATION_TYPES` in codex-auto's
 * `backend/app/services/catalog_projector.py`).
 */
export const CODEX_RELATION_TYPES: Record<string, [string, string]> = {
  calls: ['calls', 'calledBy'],
  readsFrom: ['readsFrom', 'readBy'],
  writesTo: ['writesTo', 'writtenBy'],
  publishesTo: ['publishesTo', 'publishedToBy'],
  consumesFrom: ['consumesFrom', 'consumedBy'],
  serves: ['serves', 'servedBy'],
  routesTo: ['routesTo', 'routedFrom'],
  frontedBy: ['frontedBy', 'fronts'],
  runsIn: ['runsIn', 'hosts'],
  managedBy: ['managedBy', 'manages'],
  authenticatesAs: ['authenticatesAs', 'authenticationFor'],
  deployedBy: ['deployedBy', 'deploys'],
  schedules: ['schedules', 'scheduledBy'],
  resolvesVia: ['resolvesVia', 'resolverFor'],
  storesStateIn: ['storesStateIn', 'stateStoredBy'],
  delegatesTo: ['delegatesTo', 'delegatedBy'],
};

export const CODEX_RELATION_PAIRS: [string, string][] =
  Object.values(CODEX_RELATION_TYPES);
